import React from 'react'
import '../assets/css/footer.css'
import { NavLink, useNavigate } from "react-router-dom";

function Footer() {
   const navigate = useNavigate();
  return (
   <>
    <div className="footer">
      <div>
        <h2>
          Dilip Suthar
        </h2>
        <p>
         I’m a Full-Stack Developer specializing in modern, fast, and scalable web applications.
I help businesses build digital solutions that are clean, efficient, and user-focused.
        </p>
      </div>
      <div>
         <h4>
            Socials
         </h4>
         <ul>
          <li>
            <a href="https://github.com/kumardsuthar" target="_blank">Github</a>
          </li>
            <li>
            <a href="https://www.linkedin.com/in/dilip-kumar-suthar-133791258/" target="_blank">Linkedin</a>
          </li>
            <li>
            <a href="https://www.instagram.com/d_sthr02/" target="_blank">Instagram</a>
          </li>
            <li>
            <a href="mailto:dilipsuthar9829@gmail.com" target="_blank">Email</a>
          </li>
         </ul>
      </div>
      <div>
        <h4>
          Ouick Access
        </h4>
        <ul>

          <li>
            <NavLink to="/" end>Home</NavLink>
          </li>
          <li>
            <NavLink to="/portfolio">Portfolio</NavLink>
          </li>
          <li>
            <NavLink to="/about">About</NavLink>
          </li>
          <li>
            <NavLink to="/service">Service</NavLink>
          </li>
          <li>
            <NavLink to="/contact">Contact Us</NavLink>
          </li>

        </ul>
      </div>
    </div>
    <div className="ft-cptr">
        <div>
        <p>© 2025 <span>Dilip Suthar</span>. All rights reserved.</p>
      </div>
      {/* <div>
        <ul>
          <li>
            <a href="#">Privacy Policy</a>
          </li>
          <li>
            <a href="#">Term Condition</a>
          </li>
          <li>
            <a href="#">Payment Policy</a>
          </li>
        </ul>
      </div> */}
    
    </div>
   </>
  )
}

export default Footer
